// =============================================================================
// subpageContext — lekki kontekst (tematyka serwisu + autor) dla generatorów.
// Scoped do map_id. Read-only.
// =============================================================================

import { supabase } from "@/integrations/supabase/client";

export interface MapSubpageContext {
  mapId: string;
  macroStatement: string;
  serviceName: string;
  language: string;
  authorName: string;
  websiteId: string | null;
}

export async function fetchMapSubpageContext(mapId: string): Promise<MapSubpageContext | null> {
  const { data: map } = await (supabase as any)
    .from("thematic_maps")
    .select("id, macro_statement, language, website_id, active_profile_id, name")
    .eq("id", mapId)
    .maybeSingle();
  if (!map) return null;

  let serviceName = map.name || "";
  if (map.website_id) {
    const { data: site } = await (supabase as any)
      .from("websites")
      .select("name, url")
      .eq("id", map.website_id)
      .maybeSingle();
    if (site) serviceName = site.name || site.url || serviceName;
  }

  // Autor: profil aktywny → persona → nazwa serwisu
  let authorName = "";
  if (map.active_profile_id) {
    const { data: prof } = await (supabase as any)
      .from("thematic_writing_profiles")
      .select("public_author_label, profile_name, name")
      .eq("id", map.active_profile_id)
      .maybeSingle();
    if (prof) authorName = prof.public_author_label || prof.profile_name || prof.name || "";
  }
  if (!authorName) {
    const { data: persona } = await (supabase as any)
      .from("map_persona")
      .select("full_name")
      .eq("map_id", mapId)
      .maybeSingle();
    if (persona?.full_name) authorName = persona.full_name;
  }
  if (!authorName) authorName = serviceName;

  return {
    mapId,
    macroStatement: map.macro_statement || "",
    serviceName,
    language: map.language || "pl",
    authorName,
    websiteId: map.website_id ?? null,
  };
}
